import React from "react";
import YouTube from "react-youtube";


interface PopupProps {
  children?: React.ReactNode;
  title?: string;
  show?: boolean;
  btnMessage?: string;
  btnClass?: string;
  btnImage?: any;
  mainImage?: any;
  logoImage?: any;
  imageClick?: any;
  onClick?: any;
  className?: string;
}


const Popup: React.FC<PopupProps> = ({children, title, show, btnMessage, onClick, mainImage, logoImage, imageClick, btnImage, className, btnClass}) => {
  //const [marker, setMarker] = React.useState<google.maps.Marker>();

  if(!imageClick) {
    imageClick = ()=>{};
  }

  React.useEffect(() => {
    console.log('Popup loaded');
    return () => {
      console.log('Popup destroyed');
    };
  }, []);

  className += " popup-wrap";
  if(show) {
    className += " show";
  }

  function getYouTubeId(url) {
    if (!url || typeof url !== "string") return null;
    const match = url.match(
        /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/
    );
    return match ? match[1] : null;
}

  let youtubeId = getYouTubeId(mainImage);

  const onStateChange = (event) => {
    if (event.data === (window as any).YT.PlayerState.PLAYING) {
      console.log("Started playing");
      (window as any).gtag('event', "video_play", {
        'event_category': "video",
        'event_label': title
      });
    }

    if (event.data === (window as any).YT.PlayerState.ENDED) {
      console.log("Video ended");
      (window as any).gtag('event', "video_ended", {
        'event_category': "video",
        'event_label': title
      });
    }
  };

  return (
    <div className={className}>
    <div className="popup" onClick={(e)=>e.stopPropagation()}>
      {mainImage && (youtubeId ? (
        <YouTube videoId={youtubeId} opts={{width: "300",height: "169"}} onStateChange={onStateChange} />
      ) : (
        <img className="popup_image" src={mainImage} alt={title} onClick={imageClick} />
      ))}
      <h2 className="popup_title">{title}</h2>
      <div className="popup_content">{children}</div>
      {logoImage && <img className="popup_image_bottom" src={logoImage} alt={title} />}
      {(btnMessage || btnImage) && <button className={"btn "+btnClass} onClick={onClick}>
        {btnImage ? <img src={btnImage} alt={btnMessage} /> : btnMessage}
      </button>}
      
    </div>
    </div>
  );
};


export default Popup;